import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { fetchCronSettings, QuotaPeriod, updateCronFrequency } from "../api/settingsApi";

export const maintenanceKeys = {
  cron: (
    page?: number,
    pageSize?: number,
    filters?: { wallet?: string; platform?: string; success?: string; from?: string; to?: string },
    sortBy?: string,
    sortOrder?: "asc" | "desc",
    quotaPeriod?: QuotaPeriod
  ) => ["maintenance", "cron", page, pageSize, filters, sortBy, sortOrder, quotaPeriod] as const,
};

export const useCronSettingsQuery = (
  page = 1,
  pageSize = 10,
  filters?: { wallet?: string; platform?: string; success?: string; from?: string; to?: string },
  sortBy?: string,
  sortOrder?: "asc" | "desc",
  quotaPeriod: QuotaPeriod = "daily"
) =>
  useQuery({
    queryKey: maintenanceKeys.cron(page, pageSize, filters, sortBy, sortOrder, quotaPeriod),
    queryFn: () => fetchCronSettings(page, pageSize, filters, sortBy, sortOrder, quotaPeriod),
    refetchInterval: 5_000,
    refetchIntervalInBackground: true,
  });

export const useUpdateCronFrequency = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateCronFrequency,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["maintenance", "cron"] });
    },
  });
};
